import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const PricingTypesStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '&.MuiFormLabel-root': {
        color: theme.palette.form.labelColor,
        fontSize: 14,
        paddingLeft: '16px !important',
      },
      '&.MuiFormLabel-filled': {
        paddingLeft: '0 !important',
      },
      '&.Mui-focused': {
        color: theme.palette.primary.main,
        paddingLeft: '0 !important',
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiInputBase-input': {
      fontSize: theme.typography.appFontSize,
      paddingLeft: '16px !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme.typography.pxToRem(11),
    },
    '& .MuiAutocomplete-tag': {
      background: theme.palette.primary.main,
      height: '24px',
      color: '#fff',
      fontSize: '11px',

      '& svg': {
        color: '#fff',
        height: '16px',
      },
    },
  },
}))(TextField);

export default PricingTypesStyled;
